































import { computed, defineComponent, PropType, Ref, toRefs, unref } from '@nuxtjs/composition-api'

import useCheckCarSource from '@/composables/use-check-car-source'
import useStoreLink, { useHertzStoreLink } from '@/composables/use-store-link'

import PricedCar from '@/classes/PricedCar'
import Store from '@/classes/Store'
import CarSource from '@/enums/CarSource'

import HertzPricedCar from '@/classes/Hertz/HertzPricedCar'
import HertzStore from '@/classes/Hertz/HertzStore'

export default defineComponent({
  props: {
    type: {
      type: String as PropType<'window' | 'drawer'>,
      default: 'window',
    },
    store: {
      type: Object as PropType<Store | HertzStore | null>,
      default: null,
    },
    car: {
      type: Object as PropType<PricedCar | HertzPricedCar | null>,
      default: null,
    },
    showWindowReturnOrNot: {
      type: String || null,
      default: null,
    },
  },
  setup (props) {
    const isDrawer = computed(() => props.type === 'drawer')
    const rating = computed(() => props.store?.rating)
    const img = computed(() => props.car?.images?.[0])

    const carSource = useCheckCarSource()

    const address = computed(() => {
      if (carSource === CarSource.GOGOOUT) {
        return props.store?.address
      } else if (props.showWindowReturnOrNot === 'rent') {
        return props.store?.address
      } else {
        return (props.store as HertzStore)?.endAddress
      }
    })

    const storeLink = computed(() => {
      return carSource === CarSource.GOGOOUT
        ? unref(useStoreLink(toRefs(props).store as Ref<Store>))
        : props.showWindowReturnOrNot === 'rent'
          ? unref(useHertzStoreLink('rent', toRefs(props).store as Ref<HertzStore>))
          : unref(useHertzStoreLink('return', toRefs(props).store as Ref<HertzStore>))
    })

    const minPrice = computed(() => props.car?.price)

    return {
      isDrawer,
      rating,
      img,
      address,
      storeLink,
      minPrice,
    }
  },
})
